import { WSSActionCode, WSSActionPopup } from "@/service/api/network"

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    startVARS: () => {
      WSSActionCode("autocall?wait=300&voice=B", true)
    },
    quitVARS: () => {
      WSSActionCode("seeyou", true)
    },
    showMore: () => {
      WSSActionPopup("https://vars.autocall.ai/useinfo", WSSActionCode("callend", false))
    },
    callDirect: ({ rootState }: any) => {
      WSSActionCode(
        `callDriver?calltype=msg&carnumber=${rootState.autocall.carNumber}&landpage=direct&voice=B-7&sorrywait=300&sorryvoice=C-2`,
        true
      )
    },
    callTelephone: ({ rootState }: any) => {
      WSSActionCode(`callDriver?calltype=tel&carnumber=${rootState.autocall.carNumber}&landpage=seeyou`, true)
    },
    callMessage: ({ rootState }: any) => {
      WSSActionCode(
        `callDriver?calltype=chat&carnumber=${rootState.autocall.carNumber}&landpage=message&voice=B-8&sorrywait=300&sorryvoice=C-2`,
        true
      )
    },
    callLastHistory: () => {
      WSSActionCode("reconn?calltype=tel&wait=300&voice=D-1", true)
    },
  },
}
